export default function selector(state) {
  return state.selector
}



// WEBPACK FOOTER //
// ./src/config/reducers/selector.js